import React from 'react';
import { theme } from '@citygross/design-tokens';
import { BasePaginationButton, Loading, LoadingContainer, LoadingSpinner } from './Button.styles.js';

function PaginationButton(_a) {
  var _b = _a.color,
      color = _b === void 0 ? 'primary' : _b,
      height = _a.height,
      icon = _a.icon,
      isDisabled = _a.isDisabled,
      loading = _a.loading,
      noWrap = _a.noWrap,
      _onClick = _a.onClick,
      width = _a.width,
      children = _a.children;
  return React.createElement(BasePaginationButton, {
    color: theme && theme.palette ? theme === null || theme === void 0 ? void 0 : theme.palette[color] : 'white',
    height: height,
    icon: icon,
    isDisabled: loading || isDisabled,
    loading: loading || null,
    noWrap: noWrap,
    onClick: function onClick(e) {
      return _onClick && _onClick(e);
    },
    width: width
  }, loading && React.createElement(Loading, null, React.createElement(LoadingContainer, null, React.createElement(LoadingSpinner, null))), icon || children, React.createElement("span", {
    className: "ripple"
  }));
}

export { PaginationButton };